<template>
  <span class="material-symbols-outlined">
    {{ trainingsmethodeIcon }}
  </span>
</template>

<script>
export default {
  props: {
    trainingsmethodeId: String,
  },
  computed: {
    trainingsmethodeIcon() {
      if (this.trainingsmethodeId === "rudern") {
        return "rowing";
      }

      if (this.trainingsmethodeId === "laufen") {
        return "directions_run";
      }

      if (this.trainingsmethodeId === "fahrradfahren") {
        return "directions_bike";
      }

      return "error";
    },
  },
};
</script>

<style scoped></style>
